<template>
  <div id="document-nav">
    <b-container
      style="padding: 0;"
      fluid
    >
      <b-row>
        <b-col
          cols="12"
          class="w-100"
        >
          <b-nav
            pills
            class="document-nav-wrap"
          >
            <b-nav-item
              v-for="type in documentTypes"
              :key="type.id"
              @click="selectNav(type.id)"
            >
              <span
                :class="{
                  'nav-text': true,
                  active: type.id === documentSelected
                }"
              >{{ type.name }}</span>
            </b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DocumentNav",
  props: {
    documentSelected: {
      type: Number,
      default: null
    },
    filters: {
      type: Function
    },
    documentTypes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      // documentTypes: "Account/getFilterDocumentType"
    }),
    documentFilter: {
      get() {
        return this.$store.state.Account.documentFilter;
      },
      set(val) {
        this.$store.commit("Account/SET_DOCUMENT_FILTER", val);
      }
    }
  },
  mounted() {},
  methods: {
    selectNav(value) {
      this.$emit("update:documentSelected", value);
      this.documentFilter.document_type_id = value;
      this.filters(this.documentFilter);
      //   console.log(value);
    }
  }
};
</script>

<style lang="scss" scoped>
#document-nav {
  width: 100%;
}
.document-nav-wrap {
  background-color: #6b757f;
}
.nav-text {
  color: white !important;

  &:hover {
    color: #b7b7b7 !important;
  }

  &.active {
    color: #fb822b !important;
    &:hover {
      color: #ba5d1f !important;
    }
  }
}
</style>
